/**
 * Blog Single
 */

import pinShareIconsOnScroll from "../animations/pinShareIconsOnScroll";
import sliderLayoutController from "../global/sliderLayoutController";

const BlogSingle = () => {

	if ( document.body.classList.contains( 'single-post' ) ) {
		pinShareIconsOnScroll(".single-post .blog__share__container", ".single-post #pin");
		sliderLayoutController('related-content__list-wrapper', 3, null, 'full');
	}

};

export default BlogSingle;
